
import { Component, Vue } from "vue-property-decorator";
import * as Models from "@gigalot/data-models";
import { formatDoseLabel as formatDoseLabelHelper } from "../../helpers/doses";

@Component
export default class VaccinationData extends Vue {
  vaccinations: Models.Vaccination[] = [];
  searchTerm: string = "";
  detailsDialog: boolean = false;
  details: Models.Vaccination | null = null;

  created() {
    this.$store.commit("navFuncs", {
      save: undefined,
      back: () => {
        this.$router.go(-1);
      },
    });
    this.loadVaccinations();
  }

  async loadVaccinations() {
    this.vaccinations = await this.$store.dispatch("data/getVaccinations");
  }

  get filteredVaccinations(): Models.Vaccination[] {
    const term = this.searchTerm.trim().toLowerCase();
    if (!term) return this.vaccinations;
    return this.vaccinations.filter((v) => (v.description || "").toLowerCase().includes(term));
  }

  doseKey(dose: Models.Dose, idx: number): string | number {
    return (dose.item && dose.item.description) || idx;
  }

  doseDescription(dose: Models.Dose, idx: number): string {
    return (dose.item && dose.item.description) || `Dose ${idx + 1}`;
  }

  formatDoseLabel(dose: Models.Dose): string {
    return formatDoseLabelHelper(dose);
  }

  openVaccinationDetails(vaccination: Models.Vaccination) {
    this.details = vaccination;
    this.detailsDialog = true;
  }

  closeVaccinationDetails() {
    this.detailsDialog = false;
    this.details = null;
  }
}
